// 配置型接口
import { requestSet, METHOD } from "@/utils/request";
import Cookies from 'js-cookie'
// import { BASE_URL } from "@/services/api";

/**
 * 获取用户表格配置数据(注意：MOM因为有两套登录，外部用户的token校验不通过，所以走非鉴权接口，下面的Sessionkey不触发接口校验)
 * @params { Object } obj { "rowId": 0, "jobCode": "string", "pageUrl": "string", "columnDescription": "string", "projectName": "string" }
 * @returns {Promise<AxiosResponse<T>>
 */
export async function apiGetTableSetting(params) {
  // const token = 'DCC4F8BF96794E608A24F96E351CF639'; // 拷贝的token，下面全部接口都要拷贝对应环境的lsmyTokenProd
  const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get(process.env.VUE_APP_XSRF_NAME);
  return new Promise((resolve, reject) => {
    requestSet(
      `${process.env.VUE_APP_API_PLM_URL}/center/external/callback/util/user/table/getSettingDetails`,
      METHOD.POST,
      params,
      { headers: { 'Sessionkey': token } }
    ).then(res => {
      const newEes = { data: res }
      if (res.state === 100) { resolve(newEes) }
      reject(newEes)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * 更新/新增用户表格配置数据(注意：本地启动联调，由于本地登录的token不能通过gyl的校验，所以本地联调要拷贝对应gyl环境的token,拷贝cookie的lsmyTokenProd)
 * @params { Array } list [{ "rowId": 0, "jobCode": "string", "pageUrl": "string", "columnDescription": "string", "projectName": "string" }]
 * @returns {Promise<AxiosResponse<T>>
 */
export async function apiUpdateTableSettings(params) {
  const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get(process.env.VUE_APP_XSRF_NAME);
  return new Promise((resolve, reject) => {
    requestSet(
      `${process.env.VUE_APP_API_PLM_URL}/center/external/callback/util/user/table/updateSettings`,
      METHOD.POST,
      params,
      { headers: { 'Sessionkey': token } }
    ).then(res => {
      const newEes = { data: res }
      if (res.state === 100) { resolve(newEes) }
      reject(newEes)
    }).catch((err) => {
      reject(err)
    })
  })
   //  return requestSet(`${process.env.VUE_APP_API_PLM_URL}/center/util/user/table/updateSettings`, METHOD.POST, params, { headers: { 'Sessionkey': token } });
}

/**
 * 删除用户表格配置数据(注意：本地启动联调，由于本地登录的token不能通过gyl的校验，所以本地联调要拷贝对应gyl环境的token,拷贝cookie的lsmyTokenProd)
 * @params { String } rowId
 * @returns {Promise<AxiosResponse<T>>
 */
export async function apiDeleteTableSettings(params) {
  const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get(process.env.VUE_APP_XSRF_NAME);
  return new Promise((resolve, reject) => {
    requestSet(
      `${process.env.VUE_APP_API_PLM_URL}/center/external/callback/util/user/table/deleteSetting`,
      METHOD.GET,
      params,
      { headers: { 'Sessionkey': token } }
    ).then(res => {
      const newEes = { data: res }
      if (res.state === 100) { resolve(newEes) }
      reject(newEes)
    }).catch((err) => {
      reject(err)
    })
  })
}
